import { FingerPrint } from '../model'
import fingerprint from '@fingerprintjs/fingerprintjs'
import { DeviceDetails } from '@afterpaytouch/portal-api'

export const createFingerPrint = async (): Promise<FingerPrint> => {
  const fp = await fingerprint.load()
  const result = await fp.get()
  return {
    fingerprint: fingerprint.hashComponents(result.components),
    // @ts-expect-error: OPERATION BLEED STOPPER
    language: result.components.languages.value[0][0],
    // @ts-expect-error: OPERATION BLEED STOPPER
    timezoneOffset: result.components.timezoneOffset.value,
    // @ts-expect-error: OPERATION BLEED STOPPER
    resolution: result.components.screenResolution.value.join('x'),
  }
}

const getPlugins = (): any => {
  const plugins = []
  for (let index = 0; index < navigator.plugins.length; index++) {
    // @ts-expect-error: OPERATION BLEED STOPPER
    plugins.push({
      name: navigator.plugins[index].name,
      filename: navigator.plugins[index].filename,
    })
  }
  return plugins
}

export const getDeviceDetails = (): DeviceDetails => {
  return {
    ua: navigator.userAgent?.toLowerCase(),
    os: navigator.platform,
    cn: navigator.appCodeName,
    v: navigator.appVersion?.toLowerCase(),
    ce: navigator.cookieEnabled,
    l: navigator.language,
    o: navigator.onLine,
    je: false,
    screen: {
      cd: screen.colorDepth,
      w: screen.width,
      h: screen.height,
      ha: screen.availHeight,
      wa: screen.availWidth,
    },
    tz: new Date().getTimezoneOffset(),
    plugins: getPlugins(),
  }
}

export const isAllowLogout = (isPersistentAndOptedIn: boolean, isTrusted: boolean): boolean => {
  return isPersistentAndOptedIn && !isTrusted
}
